import { Playground, Props } from "docz";
import IconMap, { IconMapRaw } from "../../../../src/components/icons/iconMap";
import SvgWrapper from "../../../../src/components/wrappers/svgWrapper";
import * as React from 'react';
export default {
  Playground,
  Props,
  IconMap,
  IconMapRaw,
  SvgWrapper,
  React
};